export default "__VITE_ASSET__clNDTD0S__"